import React, { useContext, useEffect } from "react";
import { CodesContext } from "contexts/CodesContext";
import Modal from "./Modal";
import { Input } from "components/forms/Input";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import Button from "components/forms/Button";
import { FaArrowLeft, FaCheck } from "react-icons/fa";

// synced context with live form values, must render inside <Formik> to access its context, so that's why this is a separate component
const SyncNameToContext = () => {
  const { values } = useFormikContext<{ name: string }>();
  const { setName } = useContext(CodesContext);

  useEffect(() => {
    setName(values.name ?? "");
  }, [values.name]);

  return null;
};

const ModalCodesCreateName = ({
  close,
  nextAction,
  returnAction,
}: {
  close: () => void;
  nextAction: (name: string) => void;
  returnAction: () => void;
}) => {
  const { name, setName } = useContext(CodesContext);
  const handleCreate = (name: string) => {
    nextAction(name);
    setName("");
  };

  return (
    <Modal
      width={500}
      close={() => {
        close();
        setName("");
      }}
    >
      <h1 className="text-center text-2xl font-bold">
        Geef je fotohoek een naam
      </h1>
      <p className="text-gray-500 text-sm text-center">
        Naam kun je later aanpassen
      </p>

      <Formik
        initialValues={{ name }}
        validationSchema={Yup.object({
          name: Yup.string()
            .min(1, "Vul een naam in")
            .max(100, "Naam mag maximaal 100 tekens bevatten")
            .required("Vereist"),
        })}
        onSubmit={(values) => handleCreate(values.name)}
      >
        <Form>
          <div className="flex flex-col gap-4 mt-8">
            <SyncNameToContext />
            <Input type="text" centered={true} name="name" />
            <div className="flex justify-between mt-8">
              <Button
                color="text-blue-500"
                onClick={returnAction}
                className="self-end"
              >
                <FaArrowLeft /> Terug
              </Button>
              <Button type="submit" className="self-end">
                Aanmaken <FaCheck />
              </Button>
            </div>
          </div>
        </Form>
      </Formik>
    </Modal>
  );
};

export default ModalCodesCreateName;
